import { render, staticRenderFns } from "./LeadBoardDealActivityComments.vue?vue&type=template&id=1f464c4b&"
import script from "./LeadBoardDealActivityComments.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealActivityComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports